import { render } from "./PartnerFeedbackManageView.vue?vue&type=template&id=bd92a2ae&scoped=true"
import script from "./PartnerFeedbackManageView.vue?vue&type=script&lang=js"
export * from "./PartnerFeedbackManageView.vue?vue&type=script&lang=js"

import "./PartnerFeedbackManageView.vue?vue&type=style&index=0&id=bd92a2ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd92a2ae"]])

export default __exports__